import { useState, useEffect, useCallback } from "react";
import tw from "tailwind-styled-components";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import SideModal from "../../Components/SideModal";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import AddBeneficiary from "../../Components/Payout/AddBeneficiary";
import Table from "../../Components/Payout/Table";
import ViewBeneficiaryDetails from "../../Components/Payout/ViewBeneficiaryDetails";
import moment from "moment";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SummaryCards from "../../Components/Payout/BeneficiarySummary";
import useDeleteMutation from "../../utilities/useDeleteMutation";
import DeleteModal from "../../Components/Common/DeleteModal";
import ConfirmModal from "../../Components/Common/ConfirmModal";
import useVerifyBankAccount from "../../utilities/useVerifyBankAccount";

const Beneficiaries = () => {
    const searchOptions = [
        { label: "Mobile", value: 1 },
        { label: "Name", value: 2 },
        // { label: "UTR", value: 3 },
        { label: "Account", value: 3 },
    ];
    const [summaryData, setSummaryData] = useState();
    const [selectedId, setSelectedId] = useState(null);
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [addBaneficiaryDetails, setAddBaneficiaryDetails] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [isDeleteEntity, setIsDeleteEntity] = useState(false);
    const [showActivateModal, setShowActivateModal] = useState(false);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const [searchQuery, setSearchQuery] = useState("");
    const [startDate, setStartDate] = useState(
        sessionStorage.getItem("beneficiary_startDate") ||
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        sessionStorage.getItem("beneficiary_endDate") ||
        moment(new Date()).format("YYYY-MM-DD")
    );
    const [filterType, setFilterType] = useState("");

    const buildQueryParams = useCallback(() => {
        const params = new URLSearchParams();
        params.append('startDate', startDate);
        params.append('endDate', endDate);
        if (searchQuery) {
            params.append('s', searchQuery);
        }
        if (filterType) params.append('t', filterType);
        return params.toString();
    }, [startDate, endDate, searchQuery, filterType]);

    const fetchFunction = async () => {
        const query = buildQueryParams();
        const response = await axios.get(
            `${Config.apiUrl}/cashfree/payout/list/beneficiary?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) {
            setApiData([]);

        } else {
            const data = res?.data || [];
            setApiData(data);
            setSummaryData(res?.summary);
        }
    };

    const getError = () => {
        setApiData([]);
    };

    const {
        isLoading,
        error,
        data,
        isFetching: isRefetching,
        refetch: getListMutate,
    } = useQuery(
        [
            "beneficiaries",
            startDate,
            endDate,
            searchQuery,
            filterType,
        ],
        fetchFunction,
        {
            onSuccess: getSuccess,
            onError: getError,
            refetchOnWindowFocus: false,
        }
    );


    useEffect(() => {
        if (startDate) sessionStorage.setItem("beneficiary_startDate", startDate);
        if (endDate) sessionStorage.setItem("beneficiary_endDate", endDate);
    }, [startDate, endDate]);

    //------- Add Beneficiary Account -------
    const AddBaneficiaryAccountFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/cashfree/payout/add/beneficiary`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const baneficiarySuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg);
            setAddBaneficiaryDetails(false);
            getListMutate();
        } else {
            toast.error(data?.data?.msg);
        }
    };

    const baneficiaryError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addBaneficiaryAccountLoading, mutate: addBaneficiaryAccountMutate } =
        useMutation(AddBaneficiaryAccountFunction, {
            onSuccess: baneficiarySuccess,
            onError: baneficiaryError,
        });

    const handleAddBankClose = () => {
        clearVerification();
        setAddBaneficiaryDetails(false);
    };

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            endDate: moment(values.endDate).format("YYYY-MM-DD"),
        };
        setFilterType("");
        setSearchQuery("");
        setStartDate(newValues.startDate);
        setEndDate(newValues.endDate);
        // const handler = setTimeout(() => {
        //     getListMutate();
        // }, 100);
        // return () => {
        //     clearTimeout(handler);
        // };
    };

    const handleFilterChange = (values) => {
        setFilterType(values.filterType);
        setSearchQuery(values.searchQuery);
        // const handler = setTimeout(() => {
        //     getListMutate();
        // }, 100);
        // return () => {
        //     clearTimeout(handler);
        // };
    };

    const handleClearFilters = () => {
        setFilterType("");
        setSearchQuery("");
        // const handler = setTimeout(() => {
        //     getListMutate();
        // }, 100);
        // return () => {
        //     clearTimeout(handler);
        // };
    };

    const onSummaryBoxClick = (data) => {
    };

    const {
        isLoading: deleteEntityLoading,
        mutate: deleteEntityMutate,
    } = useDeleteMutation({
        endpoint: "cashfree/payout/delete/beneficiary",
        token: user.token,
        closeModal: () => setIsDeleteEntity(false),
        refetch: () =>
            getListMutate()
    });

    const {
        isLoading: deactivateBeneficiaryLoading,
        mutate: deactivateBeneficiaryMutate,
    } = useDeleteMutation({
        endpoint: "cashfree/payout/deactivate/beneficiary",
        token: user.token,
        closeModal: () => setShowDeactivateModal(false),
        refetch: () => getListMutate(),
    });

    const {
        isLoading: activateBeneficiaryLoading,
        mutate: activateBeneficiaryMutate,
    } = useDeleteMutation({
        endpoint: "cashfree/payout/activate/beneficiary",
        token: user.token,
        closeModal: () => setShowActivateModal(false),
        refetch: () => getListMutate(),
    });

    const {
        verifyBankAccount,
        verifyAccountLoading,
        isAccountVerified,
        verifiedAccountName,
        verifyErrorMsg,
        clearVerification,
    } = useVerifyBankAccount(user.token);

    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {"Beneficiaries"}
                        <Underline />
                    </BoxTitle>
                    <Filters setAddBaneficiaryDetails={setAddBaneficiaryDetails} />
                </BoxHead>

                {(isLoading || isRefetching) && (
                    <SummarySkeletonLoading count={5} />
                )}
                {!isLoading && !isRefetching && summaryData && (
                    <SummaryCards summaryData={summaryData} onClick={onSummaryBoxClick} setSelectedId={setSelectedId} selectedId={selectedId} />
                )}

                <FilterTableWrapper>
                    <FilterWrapperWithSearch>
                        <div className="flex flex-col md:flex-row md:items-center gap-4">
                            <SearchFilterBox
                                options={searchOptions}
                                handleFilterChange={handleFilterChange}
                                handleClearFilters={handleClearFilters}
                            />
                            <DateRange
                                submitHandler={submitHandler}
                                defaultLabel={
                                    moment(startDate).format("DD MMM yyyy") +
                                    " - " +
                                    moment(endDate).format("DD MMM yyyy")
                                }
                            />
                        </div>

                    </FilterWrapperWithSearch>

                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <Table
                                apiData={error ? [] : apiData}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                                setViewDetails={setViewDetails}
                                setIsDeleteEntity={setIsDeleteEntity}
                                startDate={startDate}
                                endDate={endDate}
                            />
                            {(!error && apiData?.length === 0 && !isLoading && !isRefetching) && (
                                <NotFoundModel />
                            )}
                            {(isLoading || isRefetching) && <Loading />}
                        </TableWrapper>
                    )}
                </FilterTableWrapper>
                {(isLoading || isRefetching) && <Loading />}


                {/* {error && !isLoading && <NotFoundModel />} */}

                <SideModal
                    isOpen={addBaneficiaryDetails}
                    onClose={() => setAddBaneficiaryDetails(false)}
                >
                    <AddBeneficiary
                        handleClose={handleAddBankClose}
                        addBaneficiaryAccountLoading={addBaneficiaryAccountLoading}
                        addBaneficiaryAccountMutate={addBaneficiaryAccountMutate}
                        verifyAccountLoading={verifyAccountLoading}
                        verifyBankAccount={verifyBankAccount}
                        isAccountVerified={isAccountVerified}
                        verifiedAccountName={verifiedAccountName}
                        clearVerification={clearVerification}
                        verifyErrorMsg={verifyErrorMsg}
                    />
                </SideModal>

                <SideModal
                    isOpen={viewDetails}
                    onClose={() => setViewDetails(false)}
                >
                    <ViewBeneficiaryDetails
                        setViewDetails={setViewDetails}
                        selectedData={selectedData}
                        setShowActivateModal={setShowActivateModal}
                        setShowDeactivateModal={setShowDeactivateModal}
                    />
                </SideModal>

                <DeleteModal
                    isOpen={isDeleteEntity}
                    setOpenModel={setIsDeleteEntity}
                    message="Are you sure you want to delete this beneficiary?"
                    loading={deleteEntityLoading}
                    onClose={() => setIsDeleteEntity(false)}
                    onDelete={() =>
                        deleteEntityMutate({
                            id: selectedData?.id,
                        })
                    }
                />

                {showDeactivateModal && (
                    <ConfirmModal
                        isOpen={showDeactivateModal}
                        setOpenModel={setShowDeactivateModal}
                        title="Deactivate Beneficiary"
                        message="This beneficiary will no longer be available for payouts. You can activate it again later if needed."
                        onClose={() => setShowDeactivateModal(false)}
                        loading={deactivateBeneficiaryLoading}
                        onConfirm={() => {
                            setViewDetails(false);
                            deactivateBeneficiaryMutate({
                                id: selectedData.id,
                            });
                        }}
                        confirmBtnText="Deactivate"
                        confirmBtnClassName="
                            border border-rose-200
                            bg-rose-50
                            text-rose-600
                            hover:bg-rose-600
                            hover:text-white
                        "
                    />
                )}

                {showActivateModal && (
                    <ConfirmModal
                        isOpen={showActivateModal}
                        setOpenModel={setShowActivateModal}
                        title="Activate Beneficiary"
                        message="This beneficiary will be available for payouts again."
                        onClose={() => setShowActivateModal(false)}
                        loading={activateBeneficiaryLoading}
                        onConfirm={() => {
                            setViewDetails(false);
                            activateBeneficiaryMutate({
                                id: selectedData.id,
                            });
                        }}
                        confirmBtnText="Activate"
                        confirmBtnClassName="
                             border border-green-200
                            bg-green-50
                            text-green-600
                            hover:bg-green-600
                            hover:text-white
                        "
                    />
                )}

            </BoxContainer>
        </>
    );
};
const Filters = ({ setAddBaneficiaryDetails }) => {
    return (
        <Formik>
            <Form>
                <FilterContainer>
                    <AddBtn
                        type="button"
                        onClick={() => {
                            setAddBaneficiaryDetails(true);
                        }}
                    >
                        Add Beneficiary
                    </AddBtn>
                </FilterContainer>
            </Form>
        </Formik>
    );
};
const TableWrapper = tw.div`my-6 border bg-white rounded-md `;
const AddBtn = tw.button`border whitespace-nowrap border-gray-200 flex items-center justify-center text-white h-full rounded-md px-4 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm transition-colors duration-200`;
const FilterContainer = tw.div`grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;

export default Beneficiaries;